import styled from 'styled-components'

import Typography, { FontWeights } from 'builder/styles/typography'
import Colors from 'builder/styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const InfoText = styled.span<{ $color?: string }>`
  ${Typography.Caption}
  ${FontWeights.Regular}

  color: ${({ $color }) => $color || Colors.Neutral50};
`

export const ContactContainer = styled.div``
export const ContactText = styled.span`
  ${Typography.Caption}
  ${FontWeights.Regular}

  color: ${Colors.Neutral50};
`

export const ContactEmail = styled.a`
  ${Typography.Caption}
  ${FontWeights.Regular}

  color: ${Colors.Blue50};
`
